import { THIRD_PARTY_MEDREPS, getCurrentUserRole } from "modules/utilities/utility";
import { voitekkUserIdMap } from "modules/utilities/voitekkUSerIdMap";
import api from "../../../api";

export function customerChat(page) {
  return api.get(`active-freshchats?page=${page}`);
}

export function downloadChat() {
  return api.get("active-freshchats?download=true");
}

export function count() {
  return api.get("active-freshchats?count=true");
}
export function call(data) {
  const apiEndpoint = "call";
  return api.post(apiEndpoint, data);
}
